var _defs, _g, _path, _path2, _path3, _g2, _g3, _g4, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1100 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        opacity: .65;\n      }\n\n      .cls-1, .cls-5 {\n        fill: #388d5d;\n      }\n\n      .cls-6, .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-6, .cls-8 {\n        opacity: .5;\n      }\n\n      .cls-2, .cls-9 {\n        fill: #42bcf5;\n      }\n\n      .cls-10, .cls-3 {\n        fill: #4be061;\n      }\n\n      .cls-11, .cls-4 {\n        fill: #0339e1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M17.91,178.64h51.91c5.52,0,10.27-4.25,10.54-9.76.28-5.89-4.42-10.75-10.25-10.75H17.91c-5.66,0-10.26,4.59-10.26,10.26s4.59,10.26,10.26,10.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97.84,179.26c-6.01,0-10.88-4.87-10.88-10.88s4.87-10.88,10.88-10.88,10.88,4.87,10.88,10.88-4.87,10.88-10.88,10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.53,141.26h0c0,5.63,4.57,10.2,10.2,10.2h56.3c11.26,0,20.4-9.13,20.4-20.4H17.72c-5.63,0-10.2,4.57-10.2,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.3,152.81c-6.01,0-10.88-4.87-10.88-10.88s4.87-10.88,10.88-10.88,10.88,4.87,10.88,10.88-4.87,10.88-10.88,10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.53,195.51h0c0,5.63,4.57,10.2,10.2,10.2h76.7c0-11.26-9.13-20.4-20.4-20.4H17.72c-5.63,0-10.2,4.57-10.2,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.3,205.71c-6.01,0-10.88-4.87-10.88-10.88s4.87-10.88,10.88-10.88,10.88,4.87,10.88,10.88-4.87,10.88-10.88,10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M194.97,35.01h-51.91c-5.52,0-10.27,4.25-10.54,9.76-.28,5.89,4.42,10.75,10.25,10.75h52.2c5.66,0,10.26-4.59,10.26-10.26s-4.59-10.26-10.26-10.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M115.04,34.39c6.01,0,10.88,4.87,10.88,10.88s-4.87,10.88-10.88,10.88-10.88-4.87-10.88-10.88,4.87-10.88,10.88-10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.35,72.39h0c0-5.63-4.57-10.2-10.2-10.2h-56.3c-11.26,0-20.4,9.13-20.4,20.4h76.7c5.63,0,10.2-4.57,10.2-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.58,60.83c6.01,0,10.88,4.87,10.88,10.88s-4.87,10.88-10.88,10.88-10.88-4.87-10.88-10.88,4.87-10.88,10.88-10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.35,18.14c0,5.63-4.57,10.2-10.2,10.2h-56.3c-11.26,0-20.4-9.13-20.4-20.4h76.7c5.63,0,10.2,4.57,10.2,10.2h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.58,7.94c6.01,0,10.88,4.87,10.88,10.88s-4.87,10.88-10.88,10.88-10.88-4.87-10.88-10.88,4.87-10.88,10.88-10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.59,18.32v51.91c0,5.52,4.25,10.27,9.76,10.54,5.89.28,10.75-4.42,10.75-10.25V18.32c0-5.66-4.59-10.26-10.26-10.26s-10.26,4.59-10.26,10.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M33.97,98.25c0-6.01,4.87-10.88,10.88-10.88s10.88,4.87,10.88,10.88-4.87,10.88-10.88,10.88-10.88-4.87-10.88-10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71.98,7.94h0c-5.63,0-10.2,4.57-10.2,10.2v56.3c0,11.26,9.13,20.4,20.4,20.4V18.14c0-5.63-4.57-10.2-10.2-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.42,112.71c0-6.01,4.87-10.88,10.88-10.88s10.88,4.87,10.88,10.88-4.87,10.88-10.88,10.88-10.88-4.87-10.88-10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M17.72,7.94h0c-5.63,0-10.2,4.57-10.2,10.2v76.7c11.26,0,20.4-9.13,20.4-20.4V18.14c0-5.63-4.57-10.2-10.2-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.53,112.71c0-6.01,4.87-10.88,10.88-10.88s10.88,4.87,10.88,10.88-4.87,10.88-10.88,10.88-10.88-4.87-10.88-10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M178.28,195.33v-51.91c0-5.52-4.25-10.27-9.76-10.54-5.89-.28-10.75,4.42-10.75,10.25v52.2c0,5.66,4.59,10.26,10.26,10.26s10.26-4.59,10.26-10.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M178.9,115.4c0,6.01-4.87,10.88-10.88,10.88s-10.88-4.87-10.88-10.88,4.87-10.88,10.88-10.88,10.88,4.87,10.88,10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140.9,205.71h0c5.63,0,10.2-4.57,10.2-10.2v-56.3c0-11.26-9.13-20.4-20.4-20.4v76.7c0,5.63,4.57,10.2,10.2,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.46,100.94c0,6.01-4.87,10.88-10.88,10.88s-10.88-4.87-10.88-10.88,4.87-10.88,10.88-10.88,10.88,4.87,10.88,10.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.15,205.71h0c5.63,0,10.2-4.57,10.2-10.2v-76.7c-11.26,0-20.4,9.13-20.4,20.4v56.3c0,5.63,4.57,10.2,10.2,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.35,100.94c0,6.01-4.87,10.88-10.88,10.88s-10.88-4.87-10.88-10.88,4.87-10.88,10.88-10.88,10.88,4.87,10.88,10.88"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M605.93,153.35c6.56,0,12.03,3.83,14.49,11.48,3.28,9.84,19.69,13.95,34.45,13.95,19.69,0,32.81-7.93,32.81-18.87,0-11.48-16.41-12.58-33.91-13.95-30.35-2.73-62.62-5.47-62.62-41.29,0-26.25,24.61-43.75,61.52-43.75,21.33,0,51.13,3.83,61.25,29.8,3.55,11.21-6.56,18.32-15.31,18.32-6.56,0-10.66-2.19-13.4-8.48-5.2-11.48-22.69-12.58-32.54-12.58-18.32,0-30.35,6.84-30.35,16.95,0,13.4,14.49,10.94,33.08,13.12,30.62,3.55,63.44,5.74,63.44,41.83,0,27.07-25.7,45.66-63.98,45.66-22.97,0-56.6-4.92-64.53-35.27-2.73-10.12,6.84-16.95,15.59-16.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1092.82,123.83v-2.42h-.06c-1.45-36.13-31.18-64.97-67.66-64.97s-67.73,30.32-67.73,67.73c0,.95.03,1.9.07,2.84v59.9c0,10.31,8.36,18.67,18.67,18.67s18.74-8.39,18.74-18.74v-62.74c0-16.74,13.57-30.31,30.31-30.31s30.31,13.57,30.31,30.31v62.81c0,10.31,8.36,18.67,18.67,18.67s18.67-8.36,18.67-18.67v-62.41c0-.11,0-.22,0-.33s0-.22,0-.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M941.27,130.94c0,41.22-33.42,74.64-74.64,74.64s-74.64-33.42-74.64-74.64,33.42-74.64,74.64-74.64,74.64,33.42,74.64,74.64M866.64,90.32c-22.44,0-40.62,18.19-40.62,40.62s18.19,40.62,40.62,40.62,40.62-18.19,40.62-40.62-18.19-40.62-40.62-40.62"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M774.86,188.32v-113.65c0-9.29-7.14-17.29-16.42-17.73-9.91-.47-18.1,7.43-18.1,17.24v114.14c0,9.53,7.73,17.26,17.26,17.26s17.26-7.73,17.26-17.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M775.91,27.72c0,10.11-8.19,18.3-18.3,18.3s-18.3-8.19-18.3-18.3,8.19-18.3,18.3-18.3,18.3,8.19,18.3,18.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M526.85,188.11v-87.35c0-9.29-7.14-17.29-16.42-17.73-9.91-.47-18.1,7.43-18.1,17.24v87.84c0,9.53,7.73,17.26,17.26,17.26s17.26-7.73,17.26-17.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M527.89,53.6c0,10.11-8.19,18.3-18.3,18.3s-18.3-8.19-18.3-18.3,8.19-18.3,18.3-18.3,18.3,8.19,18.3,18.3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M463.94,205.58h0c9.48,0,17.16-7.68,17.16-17.16v-94.75c0-18.95-15.37-34.32-34.32-34.32v129.07c0,9.48,7.68,17.16,17.16,17.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M483.38,29.27c0,10.11-8.19,18.3-18.3,18.3s-18.3-8.19-18.3-18.3,8.19-18.3,18.3-18.3,18.3,8.19,18.3,18.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M555.23,205.58h0c9.48,0,17.16-7.68,17.16-17.16V59.35c-18.96,0-34.32,15.37-34.32,34.32v94.75c0,9.48,7.68,17.16,17.16,17.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M572.39,29.27c0,10.11-8.19,18.3-18.3,18.3s-18.3-8.19-18.3-18.3,8.19-18.3,18.3-18.3,18.3,8.19,18.3,18.3"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M430.91,16.45c-3-5.09-9.67-8.52-16.59-8.52-6.45,0-12.27,3.46-15.57,9.26l-49.84,135.68-52.44-136.14c-3.16-6.09-8.06-8.8-15.88-8.8-6.67,0-13.27,3.32-16.42,8.27-2.47,3.87-2.68,8.47-.6,12.94l68.92,167.12c3.07,5.92,9.06,9.31,16.43,9.31,6.39,0,12.44-3.33,15.81-8.69L430.45,30.53c3.51-6.32,2.18-11.15.46-14.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f8b165fe8db5fcfbbf40b394f1056aac.svg";
export { ForwardRef as ReactComponent };